export default "__VITE_ASSET__BUbDZVCe__"